import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import Select from '../../ui/Select/Select'
import StatusDot from '../IssueStatuses/StatusDot'
import StatusCategoryHeading from './StatusCategoryHeading'
import StatusSelectIndicator from './StatusSelectIndicator'
import {
  STATUS_GROUP_CLASS, STATUS_LIST_CLASS, groupByCategory, statusOptionClassName
} from './statusOptions'

const DEFAULT_PLACEHOLDER = 'Sélectionner...'
const COMPONENTS = { GroupHeading: StatusCategoryHeading, DropdownIndicator: StatusSelectIndicator }
const MENU_HEIGHT = 335
const BORDER_COLOR = '#d1d5db'
const PLACEHOLDER_COLOR = '#4b5563'

const CLASS_NAMES = {
  menu: () => 'tw:mt-1! tw:p-0! tw:rounded! tw:shadow-[0_0_7px_0_rgba(0,0,0,0.1)]!',
  menuList: () => `tw:px-0! ${STATUS_LIST_CLASS} `
    + 'tw:[scrollbar-width:thin] tw:[scrollbar-color:#9ca3af_transparent]',
  group: () => STATUS_GROUP_CLASS,
  option: statusOptionClassName
}

const renderStatusOption = option => <StatusDot color={option.color} label={option.label} />

const StatusSelect = ({
  inputId, issueStatuses, value = null, onChange, placeholder = DEFAULT_PLACEHOLDER
}) => {
  const options = issueStatuses.map(status => ({
    value: status.id, label: status.name, color: status.color, category: status.category
  }))
  const selected = options.find(option => option.value === value) || null

  const handleChange = useCallback(option => onChange(option?.value ?? null), [onChange])

  return (
    <Select
      classNames={CLASS_NAMES}
      components={COMPONENTS}
      controlBorderColor={BORDER_COLOR}
      controlPlaceholderColor={PLACEHOLDER_COLOR}
      formatOptionLabel={renderStatusOption}
      inputId={inputId}
      isSearchable={false}
      maxMenuHeight={MENU_HEIGHT}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      options={groupByCategory(options)}
      placeholder={placeholder}
      value={selected}
      onChange={handleChange}
    />
  )
}

StatusSelect.propTypes = {
  inputId: PropTypes.string,
  issueStatuses: PropTypes.arrayOf(PropTypes.shape({
    category: PropTypes.string,
    color: PropTypes.string,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  })),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.number
}

StatusSelect.defaultProps = {
  inputId: null,
  issueStatuses: [],
  placeholder: DEFAULT_PLACEHOLDER,
  value: null
}

export default StatusSelect
